import { CancellationStatuses, Status } from '@/common/enums/Status';
import { OfferTransportList, ReservationOfferTransport } from '@/new-transport/_models/transport-list.model';
import { countryFromLocation } from '@/_utils/country-from-location';
import { Location, Slot } from '@/reservation/reservation.model';

export function mapOfferTransportList(offerTransport: ReservationOfferTransport[]): OfferTransportList[] {
	return offerTransport.flatMap((item) => {
		return item.slot
			.filter((value) => !CancellationStatuses.includes(value.status as Status))
			.map((slotItem) => ({
				...item,
				slot: slotItem as unknown as Slot,
				reservationSlotCount: item.slot.length,
				destination: countryFromLocation(item.product.location[0] as unknown as Location),
			}))
			.sort((a, b) => {
				const dateA = new Date(a.slot.stopDeparture?.['timeDeparture']);
				const dateB = new Date(b.slot.stopDeparture?.['timeDeparture']);
				return dateA.getTime() - dateB.getTime();
			});
	});
}
